<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebarf">
<p class="fm01"><em class="italic">Front cover. At top: Tamiya’s Pzkpfw ausf H in 1/16 scale built and painted to represent a vehicle of 8.Kompanie, Panzer-Regiment 3. The photographs in the centre depict, from left to right, a Pzkpfw IV of SS-Panzer-Regiment 12 photographed during a training exercise in Belgium prior to the Normandy invasion. A Pzkpfw IV ausf B of Panzer-Regiment 22. The regiment’s 8.Kompanie was composed of very early models of this tank. A Pzkpfw IV ausf H of 5.Kompanie, SS-Panzer-Regiment 12 photographed near the front. The illustration at the foot of the page depicts a Pzkpfw IV ausf H of 7.Kompanie, SS-Panzer-Regiment 1. This vehicle is also shown in the Camouflage &amp; Markings section of this book</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Fm02.vue?5a6fd4b5